<template>
  <div class="p_cc-ssc">
    <v-p-top @showResult="onShowResult"
             :phase="phase"
             :next_phase="next_phase"
             :open_time="open_time"
             :records="records"
             :name="head.title"
             @end="handle_end"
             :remain_time="remain_time"
             :block_time="block_time"
             @change="changeFp"
    >
      <ul slot="recodeNumber" class="num_record">
        <li v-for="(num, index) in records" :key="'re' + index" class="number3 item item2"
            :class="'number3' + num"></li>
      </ul>
    </v-p-top>

    <template v-if="!$route.query.notice">
      <v-tab class="page-tabs" v-if="tabs.length" @onChangeTab="onTabChanged" :current="tabs[curTab].value" :tabs="tabs"
             :border="true"/>

      <div class="cc_ssc-main page-wrapper" :style="contentStyleObj">

        <c-input class="c-input" v-model="chip" @again="handle_again" @certain="certain_handle"
                 @reset="reset_selected"></c-input>
                 

        <component :chip="chip.toString()" ref="c_model_input" :is="componentName" :data="tabItemData"
                   class="component-page"></component>

        <c-input class="c-input" v-model="chip" @again="handle_again" @certain="certain_handle"
                 @reset="reset_selected"></c-input>

        <v-statistic @showRule="onShowRule" class="page-side"></v-statistic>
      </div>
    </template>
    <template>
      <div class="listen">
        <audio controls="controls" hidden id="audio1">
          <source src="../../../assets/1.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio2">
          <source src="../../../assets/2.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio3">
          <source src="../../../assets/3.mp3" type="audio/mpeg"/>
        </audio>
      </div>
    </template>
    <order ref="order" @submit="order_sub" :orders="orders"/>
  </div>
</template>

<script>
  import methods from '../methods';
  import Order from '../../../components/dialog/order';
  import VStatistic from '../../../components/c_statistics';
  import CSC1 from '../../../components/pageComponents/cc_ssc/cc_ssc-1'
  import CSC2 from '../../../components/pageComponents/cc_ssc/cc_ssc-2'
  import VPTop from '../../../components/c_top';
  import VTab from '../../../components/c_tab';
  import CInput from '../../../components/c_a-input';
  import eventMixin from '../../../utils/eventMixin';
  import {mapState, mapActions} from 'vuex';
  import {computedDataSsc} from '../../../utils/computed';
  const each = (cb, el) => {
    (el.name === 'g_input_selected_item' || el.name === 'g_input_selected_item_type_2') && cb(el);
    if (el.$children.length > 0) el.$children.forEach(child => each(cb, child));
  };

  export default {
    name: "cc_ssc",
    mixins: [eventMixin, methods],
    components: {
      Order,
      CSC1,
      CSC2,
      VPTop,
      VTab,
      CInput,
      VStatistic
    },
    data() {
      return {
        origin_list: null,
        // 最后选择的订单号
        orders: [],
        order_subing: false,
        // 连码选择
        curInnerTab: 0,
        // 筹码
        chip: '',

        // 时时彩
        time: 0,
        contentStyleObj: {
          height: ''
        },
      }
    },
    computed: {
      ...mapState({
        notice: state => state.notice,
        curTab: state => state.home_cc_ssc.curTab,
        headTabs: state => state.home.headTabs,
        tabs: state => state.home_cc_ssc.tabs,
        odds: state => state.home_cc_ssc.odds,
        lottery: state => state.home_cc_ssc.lottery,
        order_history: state => state.home_cc_ssc.order_history,
        longQueue: state => state.home.longQueue,
        statistics: state => state.home.statistics
      }),
      current() {
        return this.tabs[this.curTab] || null;
      },
      // 封盘倒计时
      remain_time() {
        return this.lottery.next_info.remain_time;
      },
      // 下一期开盘倒计时
      block_time() {
        return this.lottery.next_info.block_time;
      },
      next_phase() {
        return this.lottery.next_info.period;
      },
      open_time() {
        return this.lottery.next_info.open_time || '';
      },
      // 期数
      phase() {
        return this.lottery.latest_result.period;
      },
      // 开奖号码
      records() {
        return this.lottery.latest_result.number ? this.lottery.latest_result.number.split(',') : [];
      },
      head() {
        return this.headTabs.find(item => item.lottery_type == this.$route.query.lottery_type) || {};
      },
      componentName() {
        return !parseInt(this.curTab) ? 'c-s-c1' : 'c-s-c2';
      },
      tabItemData() {
        const odds = this.odds.map(item => {
          if (!item._status) item._status = item.status;
          // 封盘中
          if (!this.time) {
            item.status = 3;
          } else if (item.status === 3) {
            item.status = item._status;
          }
          return item;
        });

        return computedDataSsc(odds, this.current, this.curInnerTab);
      }
    },
    methods: {
      ...mapActions({
        createOrder: 'home_cc_ssc/createOrder',
        getNewLotteryRes: 'home_cc_ssc/getNewLotteryRes',
        updateUserInfo: 'root/updateUserInfo',
        getLotteryLatest: 'home/getLotteryLatest',
        getLongQueue: 'home/getLongQueue',
        getStatistics: 'home/getStatistics'
      }),
      getHeight() {
        this.contentStyleObj.height = window.innerHeight - 220 + 'px';
      },
    },
    created() {
      var lett = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          if (lett.$refs.order.showOrderDialog === true) {
            lett.$refs.order.handle_submit();
          } else {
            lett.certain_handle();
          }
        }
      }
      window.addEventListener('resize', this.getHeight);
      this.getHeight();
    },

  }
</script>

<style scoped lang="stylus">
  .p_cc-ssc {
    .cc_ssc-main {
      background-color #ffffff
    }
  }

  .num_record {
    text-align left
    margin-top 10px

    > .item2 {
      width 27px
      height 27px
    }

    > .item2 + .item2 {
      margin-left 25px
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/cc_ssc/index.vue